import { RoutingStrategy } from "@app/routing/types";
import "@app/i18n";

import("./bootstrap").then(({ mount }) => {
  const localRoot = document.getElementById("root")!;
  mount({
    mountPoint: localRoot,
    routingStrategy: RoutingStrategy.browser,
  });
});

if (module.hot) {
  module.hot.accept(function (err: any) {
  });
}

export {};
